import { observer } from 'mobx-react'
import React from 'react'
import VerificationErrorComponent from 'src/components/errors/VerificationErrorComponent'
import { applicationStore } from 'src/store/ApplicationStore'
import { useTranslation } from 'react-i18next'

const BankError = observer(() => {
    const { t } = useTranslation();
    return (
        <VerificationErrorComponent buttonTitle={t('actions.retry')} buttonNavigateUrl={`/?aid=${applicationStore.aidCode}`} />
    )
})

export default BankError
